import { render, staticRenderFns } from "./CriarDiretorioArquivoDialog.vue?vue&type=template&id=a51cf50e&"
import script from "./CriarDiretorioArquivoDialog.vue?vue&type=script&lang=js&"
export * from "./CriarDiretorioArquivoDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports